import type { Post } from "@/lib/posts";
import { blogDateTime, formatBlogDate, formatBlogDateCompact } from "@/lib/blog-dates";
import { BlogCardMedia } from "./BlogCardMedia";
import { TransitionLink } from "./TransitionLink";

function BlogCardBody({
  post,
  dateLabel,
  priority = false,
}: {
  post: Post;
  dateLabel: string;
  priority?: boolean;
}) {
  return (
    <>
      <BlogCardMedia imageUrl={post.imageUrl} title={post.title} priority={priority} />
      <div className="blog-card-body">
        <div className="blog-card-meta">
          <span className="blog-card-chip">Post</span>
          <time dateTime={blogDateTime(post.date)}>{dateLabel}</time>
        </div>
        <h2>{post.title}</h2>
        <p>{post.excerpt}</p>
        <span className="blog-card-more">Read article →</span>
      </div>
    </>
  );
}

export function BlogCard({
  post,
  compactDate = false,
  /** When false, render a non-focusable div (for aria-hidden orbit neighbors). */
  interactive = true,
}: {
  post: Post;
  compactDate?: boolean;
  interactive?: boolean;
}) {
  const dateLabel = compactDate
    ? formatBlogDateCompact(post.date)
    : formatBlogDate(post.date);

  if (!interactive) {
    return (
      <div className="blog-card">
        <BlogCardBody post={post} dateLabel={dateLabel} />
      </div>
    );
  }

  return (
    <TransitionLink href={`/blogs/${post.slug}`} className="blog-card">
      <BlogCardBody post={post} dateLabel={dateLabel} priority />
    </TransitionLink>
  );
}
